module.exports = __webpack_public_path__ + "img/banner_icon_2.c8959338.jpg";